import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
// Keep below imports -
// This was on the 1st design, This might come up in next sprints.
// Removed from current sprint because currently it doesn't have any functionality
// import IconButton from "@material-ui/core/IconButton";
// import MenuIcon from "@material-ui/icons/Menu";
import { Link } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useStyles } from "./styles";

const kooeeLogo = require("../../../resources/images/nrg-logo-black.svg");

export default function HeaderMenu(props) {
  const classes = useStyles();
  const homePath = props.noFnPayBgt && props.noFnPayBgt==='true' ? '/?no_fn_pay_bgt=true' : '/';
 
  return (
    <Grid item>
      <AppBar position="static" color="primary">
        <Toolbar>
          <Link to={homePath}>
          <img src={kooeeLogo} width="150" alt="NRG" />
          </Link>
          <Typography variant="h6" className={classes.title}></Typography>
          {/* Keep below section This was on the 1st design, This might come up in next sprints. 
          Removed from current sprint because currently it doesn't have any functionality*/}
          {/* <IconButton edge="end" className={classes.menuButton} color="inherit" aria-label="menu">
            <MenuIcon />
          </IconButton> */}
        </Toolbar>
      </AppBar>
    </Grid>
  );
}
